import { memo } from 'react';
import { FONT_PAIRINGS } from '../constants';

const FontsTab = memo(({ fonts, onFontSwap, t, theme }) => (
  <div>
    {fonts.length > 0 && (
      <p style={{ fontFamily: 'var(--sans)', fontSize: '12px', color: t.muted, marginBottom: '14px' }}>
        Current: <span style={{ color: t.fg, fontWeight: 500 }}>{fonts.join(' + ')}</span>
      </p>
    )}
    <p style={{ fontFamily: 'var(--sans)', fontSize: '12px', color: t.muted, marginBottom: '10px' }}>
      Pick a new font pairing
    </p>
    {FONT_PAIRINGS.map(([h, b], i) => (
      <button key={i} onClick={() => {
        if (fonts[0]) onFontSwap(fonts[0], h);
        if (fonts[1]) onFontSwap(fonts[1], b);
      }} style={{
        width: '100%', padding: '14px 16px', marginBottom: '6px', textAlign: 'left',
        border: `1px solid ${t.border}`, borderRadius: '10px',
        background: theme === 'light' ? '#fff' : 'rgba(242,239,233,0.02)',
        cursor: 'pointer', transition: 'all .2s',
      }}
        onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(201,168,76,0.2)'; e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)'; }}
        onMouseLeave={e => { e.currentTarget.style.borderColor = t.border; e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none'; }}
      >
        <span style={{ fontFamily: h + ', serif', fontSize: '16px', color: t.fg, display: 'block', marginBottom: '2px' }}>{h}</span>
        <span style={{ fontFamily: 'var(--sans)', fontSize: '11px', color: t.muted }}>paired with {b}</span>
      </button>
    ))}
  </div>
));

FontsTab.displayName = 'FontsTab';
export default FontsTab;
